import Hero from './components/Hero';

export default function Home() {
  return (
    <div className="min-h-screen bg-[#f6f3ee]">
      <Hero />
    </div>
  );
}